import type { ICampaignWizardForm } from "../../../../../../../../../shared/types/form.type";

import { isAppIdAcceptableForSubmit } from "./validate-app-id";
import {
	areCampaignAdGroupTextsValid,
	isCampaignNameTextValid,
} from "./validate-text-fields";
import { isNonNegativeMoneyAmountString } from "./validate-number-inputs";

export type CampaignFormSubmitExtras = {
	/** Чернетковий текст у полях headlines/descriptions груп блокує сабміт */
	adGroupDraftsBlockSubmit?: boolean;
};

/** Чи можна активувати кнопку «Створити» (усі обов’язкові поля кампанії заповнені). */
export function isCampaignFormReadyForSubmit(
	accountId: string,
	formData: ICampaignWizardForm | null,
	extras?: CampaignFormSubmitExtras,
): boolean {
	if (!accountId || !formData) return false;
	if (extras?.adGroupDraftsBlockSubmit) return false;
	const { budget, campaign, adgroups } = formData.campaign_context;
	return (
		isNonNegativeMoneyAmountString(budget.amount_micros) &&
		!!campaign.name?.trim() &&
		isCampaignNameTextValid(campaign.name) &&
		!!campaign.status &&
		campaign.status !== "none" &&
		!!campaign.app_store &&
		campaign.app_store !== "none" &&
		isAppIdAcceptableForSubmit(campaign.app_id, campaign.app_store) &&
		isNonNegativeMoneyAmountString(campaign.target_cpa_micros) &&
		campaign.selective_optimization_conversion_actions.length > 0 &&
		campaign.geo_targets.length > 0 &&
		areCampaignAdGroupTextsValid(adgroups ?? [])
	);
}
